<div class="headersp infoHead">
  <i class="far fa-info-circle" style="font-size:18px"></i> &nbsp;Accèdez à de précieux conseils et obtenez les réponses à vos questions en parcourant notre page d'aide et astuces.
  <span class="closeheadsp closeInfoHead">
    <i class="fas fa-times"></i>
  </span>
</div>
<div class="contblocsp1">
  <div class="blochelp ui-card">
    <div class="ui-card__header ui-card__header--bordered">
      <h2 class="ui-card__title"><i class="fa-duotone fa-light fa-life-ring icduotone"></i> &nbsp; Centre d'aide</h2>
    </div>
    <div class="ui-card__body">
      <p class="txtsp">
        Consultez les sujets de la rubrique ou réalisez une recherche par mot clé pour obtenir des informations précises.
      </p>
      <input type="text" class="searchhelp" placeholder="Recherche">
      <div class="searchhelpic"><i class="fal fa-search"></i></div>
      <div class="conttopic">
      </div>
    </div>
  </div>
</div>
<div class="contblocsp2">
  <div class="blocast ui-card">
    <div class="ui-card__header ui-card__header--bordered">
      <h2 class="ui-card__title"><i class="fa-duotone fa-light fa-box-heart icduotone"></i> &nbsp; Boîte à astuces</h2>
    </div>
    <div class="ui-card__body">
      <p class="txtsp">
       Prochainement disponible.
      </p>
    </div>
  </div>
  <div class="blocblog ui-card">
    <div class="ui-card__header ui-card__header--bordered">
      <h2 class="ui-card__title"><i class="fa-duotone fa-light fa-square-rss icduotone"></i> &nbsp; Blog Wilout</h2>
    </div>
    <div class="ui-card__body">
      <p class="txtsp">
        Visitez notre blog pour suivre les dernières actualités et découvrir des conseils sur l'organisation d'évènements avec nos solutions.
      </p>
      <br>
      <a href="https://www.wilout.com/blog-general" target="newBlank" class="linkblogsp"><i class="fas fa-square"></i> &nbsp; Tous</a>
      <br>
      <a href="https://www.wilout.com/blog-actualites" target="newBlank" class="linkblogsp"><i class="fas fa-square"></i> &nbsp; Actualités</a>
      <br>
      <a href="https://www.wilout.com/blog-billetterie" target="newBlank" class="linkblogsp"><i class="fas fa-square"></i> &nbsp;  Billetterie</a>
      <br>
      <a href="https://www.wilout.com/blog-cashless" target="newBlank" class="linkblogsp"><i class="fas fa-square"></i> &nbsp;  Cashless</a>
      <br><br>
      <a href="https://www.wilout.com/blog-general" target="newBlank" class="btnblogsp-link">
        <button type="button" class="ui-btn ui-btn--secondary ui-btn--sm ui-btn--auto btnblogsp-pos">
          <i class="far fa-external-link-square"></i> &nbsp; Accèder au blog
        </button>
      </a>
    </div>
  </div>
</div>
